import {mapGetters, mapActions} from 'vuex';
import fullCalendar from 'vue-fullcalendar';
import DownloadCsv from 'vue-json-csv';

// Utils
import moment from 'moment';

// Constants.
import * as REMINDER from '@/store/constants/reminder';
import * as USER from '@/store/constants/user';

// Modals
import AddReminderFormModal from './../AddReminderFormModal';
import ReminderFormModal from './../ReminderFormModal';

// Mixins
import WithFilters from '@/mixins/with-filters';
import WithDateFilters from '@/mixins/with-date-filter';
import NotificationMixin from '@/mixins/notification';

// Common
import DropDownFilter from '@/views/Common/Filter/DropDownFilter';
import ListWithSpinner from '@/components/ListWithSpinner';
import SearchInput from '@/components/SearchInput';
import Notification from '@/views/Common/Notification';

export default {
  data() {
    return {
      name: 'ReminderList',
      fields: [
        {key: 'title', sortable: true},
        'notes',
        {key: 'reminder_date_time', sortable: true},
        {key: 'status', sortable: true},
        'action'
      ],
      actions: {
        pending: [{key: 'completed', label: 'Complete'}, {key: 'deleted', label: 'Delete'}],
        completed: [{key: 'pending', label: 'Pending'}],
        deleted: [{key: 'pending', label: 'Pending'}]
      },
      isProcessing: false,
      view: 'calendar',
      reminderToUpdate: {},
      showForm: false
    }
  },

  mixins: [NotificationMixin, WithDateFilters, WithFilters],

  components: {
    AddReminderFormModal,
    ListWithSpinner,
    SearchInput,
    fullCalendar,
    DropDownFilter,
    ReminderFormModal,
    DownloadCsv,
    Notification
  },

  computed: {
    ...mapGetters({
      user: USER.GET_USER,
      reminders: REMINDER.GET_REMINDER_LIST
    }),

    /**
     * Format the items to add row variant
     *
     * @returns {Array}
     */
    items() {
      let items = [];

      if (this.reminders.data) {
        for (let item of this.reminders.data) {
          items.push({
            ...item, ...{
              start: item.reminder_date_time,
              end: item.reminder_date_time,
              cssClass: this.getStatusColor(item.status)
            }
          });
        }
      }

      console.log(items, 'items');
      return items;
    },
  },

  methods: {
    ...mapActions({
      listReminders: REMINDER.ACTION_LIST_REMINDERS,
      updateReminder: REMINDER.ACTION_UPDATE,
      deleteReminder: REMINDER.ACTION_DELETE
    }),

    handleShowReminder(item) {
      this.resetNotification();
      this.reminderToUpdate = item;
      this.showForm = true;
    },

    saved() {
      this.showSuccessNotification('Reminder has been successfully saved');
      this.refreshData();
    },

    updated() {
      this.showSuccessNotification('Reminder has been successfully updated');
      this.showForm = false;
      this.refreshData();
    },

    /**
     * Get item action.
     *
     * @param status
     * @returns {*}
     */
    getItemActions(status) {
      return this.actions[status];
    },

    /**
     * Handle row action.
     *
     * @param item
     * @param id
     */
    handleRowAction(item, id) {
      return ('deleted' === item.key)
        ? this.deleteReminder({id}).then(() => this.refreshData())
        : this.updateReminder({id, status: item.key}).then(() => this.refreshData());
    },

    /**
     * Get row variant
     *
     * @param status
     * @returns {string}
     */
    getStatusColor(status) {
      return (status === 'completed') ? 'success' : 'secondary';
    },

    /**
     * Refresh data.
     */
    refreshData() {
      this.isProcessing = true;

      let filters = this.formatFilters();

      if (this.wildcard) {
        filters = {...filters, ...{wildcard: this.wildcard}};
      }

      filters = {
        ...filters, ...{
          page: this.reminders.current_page,
          order_by: [`created_at,desc`]
        }
      };

      this.listReminders(filters).then(this.isProcessing = false);
    },

    /**
     * Filter list.
     */
    filterList: window._.debounce(function (item) {
      this.wildcard = (item !== '') ? [`title,like,${item}`] : null;
      this.refreshData();
    }, 300),

    handlePaginate() {
      this.refreshData();
    },

    init() {
      this.setDateFilterKeyField('reminder_date_time');
      this.setDefaultDateFilter( {
        key: 'this_month', text: 'This Month', value: {
          from: moment().startOf('month').format('YYYY-MM-D'),
          to: moment().endOf('month').format('YYYY-MM-DD')
        }
      });

      this.refreshData();
    }
  },

  created() {
    this.init();
  }
}



// WEBPACK FOOTER //
// ./src/views/Reminder/js/reminder-list.js